<highcharts-chart
  class="m-circular-progress"
  [Highcharts]="Highcharts"
  [options]="chartOptions">
</highcharts-chart>
